/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum QueryCommitStatus {
  JobNotFound = 'JobNotFound',
  Error = 'Error',
  CompletedOk = 'CompletedOk',
  Prepared = 'Prepared',
  InProgress = 'InProgress',
  WaitingForPickup = 'WaitingForPickup',
  PaymentRequired = 'PaymentRequired'
}
